var ExpectationsCustomizer = require("components/users/teachers/ExpectationsCustomizer");

class OnboardingStageSetAssignments extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = {
			selectedGoal: null
		};
	}

	toggleGoal(goalKey) {
		this.setState({ selectedGoal: goalKey });
	}

	afterSubmit(preferenceHash) {
		this.props.onComplete({ selectedGoal: this.state.selectedGoal });
		Mycroft.newEvent({ category: "Onboarding", action: "goal-selected", label: this.state.selectedGoal });
	}

	goalDescription(goalKey) {
		if (goalKey == COMPREHENSION) {
			return "I need an easy way to check my students' comprehension.";
		} else if (goalKey == WRITING) {
			return "I need help improving my students' writing skills.";
		} else if (goalKey == MOTIVATION) {
			return "I need help motivating my students to read more.";
		}
	}

	renderGoalOption(goalKey) {
		var className = "largeObject clickableElement";
		if (this.state.selectedGoal == goalKey) {
			className += " selectedGoal";
		}

		return (
			<div className={ className } key={ goalKey }
				onClick={ this.toggleGoal.bind(this, goalKey) }>
				<div className="goalObjectContent">
					{ this.goalDescription(goalKey) }
				</div>
			</div>
		);
	}

	render() {
		var goalObjects = _.map(GOAL_OPTIONS, (goalKey) => {
			return this.renderGoalOption(goalKey);
		});
		var goalOptions = (
			<div className="goalOptions">
				{ goalObjects }
			</div>
		);

		var goalQuestion = (
			<div className="singleCol">
				<p className="onboardingGreeting">
					What is the main reason you need Whooo's Reading?
				</p>
			</div>
		);

		if (this.state.selectedGoal) {
			var assignmentCustomizer = (
				<ExpectationsCustomizer key={ this.state.selectedGoal }
					afterChange={ this.afterSubmit }
					onboardingDefault={ this.state.selectedGoal } />
			);
		} else {
			// Render this early, so it can finish loading, but hide it
			var assignmentCustomizer = (
				<div style={ { display: "none" } }>
					<ExpectationsCustomizer key="preloader"
						afterChange={ this.afterSubmit }
						onboardingDefault={ this.state.selectedGoal } />
				</div>
			);
		}

		return (
			<div className="onboardingStage onboardingStageSetAssignments clearfix">
				{ goalQuestion }
				{ goalOptions }
				{ assignmentCustomizer }
			</div>
		);
	}
}

var COMPREHENSION = "check-comprehension";
var WRITING = "writing-practice";
var MOTIVATION = "reading-motivation";

var GOAL_OPTIONS = [
	COMPREHENSION, WRITING, MOTIVATION
];


OnboardingStageSetAssignments.propTypes = StrictPropTypes({
	track: PropTypes.string.isRequired,
	onComplete: PropTypes.func.isRequired,
	// only used for the final stage of onboarding
	endOnboarding: PropTypes.func,
	persistentData: PropTypes.object
});

module.exports = OnboardingStageSetAssignments;



// WEBPACK FOOTER //
// ./modules/components/users/teachers/onboarding/OnboardingStageSetAssignments.js